export default __webpack_public_path__ + "static/media/logo-tnc-white.12c1adba.png";